import React from "react";
import { MailOption } from "grommet-icons";
import { Tip } from "grommet";
import { useTranslation } from "react-i18next";

// Inline red envelope icon shown next to a status pill when comms
// with the guest could not be delivered. Inline (not absolutely
// positioned) so it never gets clipped by table cells.
export default function CommsFailedBadge({ reason, size = "small" }) {
  const { t } = useTranslation();
  const content = reason || t("comms.commsFailedBadge");
  return (
    <Tip content={content}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: 4,
          color: "red",
        }}
        aria-label={content}
      >
        <MailOption size={size} color="status-critical" />!
      </span>
    </Tip>
  );
}
